import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CorporateEmployeesService } from '@ridango/components/lib/corporate-employees/corporate-employees.service';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [CorporateEmployeesService]
})
export class CorporateEmployeesModule {}
